export default __webpack_public_path__ + "static/media/Bloodbrute Legguards.bbda7336.jpg";